import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-card-settings',
  templateUrl: './card-settings.component.html',
  styleUrl: './card-settings.component.scss'
})
export class CardSettingsComponent {
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() titleButton: string = '';
  @Input() url: string = '';

  constructor(private router: Router) {}

  redirecionar() {
    if (this.url) {
      this.router.navigateByUrl(this.url);
    } else {
      console.error('URL de redirecionamento não fornecida!');
    }
  }
}